import { z } from 'zod';

export const IsoDateCodec = z.date();

export const NullableIsoDateCodec = z.date().nullable();

const parseDate = (value: unknown, ctx: z.RefinementCtx): Date => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Invalid date value' });
      return z.NEVER;
    }
    return value;
  }
  if (typeof value === 'string') {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Invalid ISO date string' });
      return z.NEVER;
    }
    return parsed;
  }
  ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Expected Date or ISO string' });
  return z.NEVER;
};

export const IsoDatetimeToDateSchema = z.union([z.date(), z.string()]).transform((value, ctx) => parseDate(value, ctx));

export const NullableIsoDatetimeToDateSchema = z
  .union([z.date(), z.string(), z.null(), z.undefined()])
  .transform((value, ctx) => {
    if (value == null) {
      return null;
    }
    return parseDate(value, ctx);
  });

export const IsoDateRangeCodec = z
  .object({
    start: z.date().nullable(),
    end: z.date().nullable(),
  })
  .nullable();
